<div class="stand-item-container" (click)="centerOnStand()">
  <div class="stand-layout {{ clickable ? 'clickable' : '' }}">
    <div class="stand-svg-container" #dataContainer></div>
    <div class="stand-data">
      <div class="tiny-text">
        Stand {{ index + 1 }}
        @if (allowRemove) {
          <span
            class="remove-stand tiny-text"
            [matTooltipDisabled]="!approvalRequired"
            matTooltipClass="fc-tooltip"
            matTooltipPosition="right"
            matTooltip="In order to change your site, please reject the pending changes first."
            (click)="deleteStand()">
            <fa-icon [icon]="['far', 'trash']" class="gray size-12"></fa-icon>
          </span>
        }
      </div>
      <div class="value-text">
        Estimated Annual Value
        <span class="value-amount">{{ getValuation() }}</span>
      </div>
      <div class="med-text">Forested Acres: {{ acreage }}</div>
    </div>
  </div>
</div>
